<!-- Banner Container (App-wide notifications) -->
<app-banner-container />
<!-- Main Application Outlet -->
<router-outlet />
